import React from "react";
import "../../index.css";
import "./News.css";
import NewsCard from "../../Component/NewsCard/NewsCard";
import BikeImage from "../../Images/News/Bike.jpg";

const NewsPage = () => {
  return (
    <>
      <div className="layout news-layout">
        <div className="container main-news-container">
          <div className="title main-news-title">News</div>
          <div className="news-list">
            <NewsCard
              title={"Senam Bareng Instruktor Ganteng"}
              author={"Muslimah"}
              date={"21 Februari 2025"}
              subtitle={
                "Kemaren BAS senam bareng dengan instruktor Uray Putra."
              }
              img={BikeImage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsPage;
